import React from "react";
import { PickupCargoInternodeRouteBinsDataInterface } from "../../../../redux/interfaces/raports.interface";

import { getDateAndTime } from "../../../../utils/dateAndTime";
import { useAppDispatch } from "../../../../redux/hooks";
import CustomButton from "../../../../components/CustomButton";
import SvgIcon from "../../../../helpers/SvgIcon";
import {
  openClosePackageCargoInternodeRouteModal,
  setSelectedCargoInternodeItemForClosing,
} from "../../../../redux/reducer/raports.reducer";

function BinsTable({
  bins,
}: {
  bins: PickupCargoInternodeRouteBinsDataInterface[];
}) {
  const dispatch = useAppDispatch();

  const BinStatusesValues = [
    { value: 0, label: "BIN creat" },
    { value: 1, label: "BIN scanat in masina" },
    { value: 2, label: "BIN scanat in nod" },
    { value: 3, label: "BIN golit cu neconformitati" },
    { value: 4, label: "BIN golit fara neconformmitati" },
  ];

  const getStatusLabelForBin = (status: number) => {
    const getStatus = BinStatusesValues.find((s) => s.value === status);

    return getStatus?.label;
  };

  return (
    <div className="table-responsive mt-3">
      <h2 className="mb-5">Binuri</h2>

      <table className="table table-hover align-middle mb-0 fw-bolder">
        <thead className="table-light">
          <tr className="text-muted">
            <th className="ps-4">Nr. BIN</th>
            <th>Client</th>
            <th>Adresa ridicare</th>
            <th>Punct ridicare</th>
            <th>Nod preluare</th>
            <th>Nod destinatie</th>
            <th>Status</th>
            <th>Data crearii</th>
            <th className="d-flex justify-content-end pe-2">Actiune</th>
          </tr>
        </thead>
        <tbody>
          {bins.map((b) => {
            const handleCloseBin = () => {
              dispatch(
                setSelectedCargoInternodeItemForClosing({
                  id: b.id_bin,
                  type: "BIN",
                  label: b.sn_bin,
                }),
              );
              dispatch(openClosePackageCargoInternodeRouteModal());
            };
            return (
              <tr key={b.id_bin}>
                <td className="ps-4 py-5">{b.sn_bin}</td>
                <td>{b.client}</td>
                <td>{b.adresa_ridicare}</td>
                <td>{b.punct_ridicare}</td>
                <td>{b.nod_preluare}</td>
                <td>{b.nod_destinatie}</td>
                <td>
                  <span className="badge px-3 py-2 text-info bg-info bg-opacity-10">
                    {getStatusLabelForBin(b.status)}
                  </span>
                </td>
                <td>
                  <span className="badge px-3 py-2 text-info bg-info bg-opacity-10">
                    {getDateAndTime(b.data_operatie)}
                  </span>
                </td>
                <td className="d-flex justify-content-end pe-2">
                  <CustomButton
                    variant="contained"
                    color="error"
                    tooltipTitle="Inchidere bin"
                    onClick={handleCloseBin}>
                    <SvgIcon type="CLOSE_ICON" />
                  </CustomButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default BinsTable;
